import React from 'react';
import PropTypes from 'prop-types';



const CardSocialMedia = ({ title, description, iconRed, linkRed }) => (
    <article className="red-social-portfolio">
        <a href={linkRed} ><img src={iconRed} alt={title} /></a>
        <h2> {title} </h2>
        <p> {description} </p>
    </article>
)


// PropTypes & propDeafault
CardSocialMedia.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    iconRed: PropTypes.string,
    linkRed: PropTypes.string
}
CardSocialMedia.defaultProps = {
    title: 'Title',
    description: 'Description',
    iconRed: 'https://www.flaticon.es/svg/vstatic/svg/595/595067.svg?token=exp=1615905960~hmac=e2e3131d80d84addca11f2633a50c141',
    linkRed: '/'
}

export default CardSocialMedia;
